var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThumbsDownFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78125 14C8.96875 14.1562 8.1875 13.625 8 12.8125L7.9375 12.4375C7.75 11.4062 7.15625 10.4688 6.34375 9.8125L6.125 9.625C5.40625 9.0625 5 8.21875 5 7.28125V6.5V5V3.8125C5 2.8125 5.5 1.875 6.3125 1.3125L7.53125 0.53125C8.03125 0.1875 8.59375 0 9.1875 0H12.25C13.0625 0 13.75 0.6875 13.75 1.5C13.75 1.625 13.7188 1.75 13.6875 1.84375C14.3125 2.03125 14.75 2.59375 14.75 3.25C14.75 3.5625 14.6562 3.8125 14.5312 4.03125C15.2188 4.1875 15.75 4.78125 15.75 5.5C15.75 6 15.5312 6.40625 15.1875 6.6875C15.6562 6.9375 16 7.4375 16 8C16 8.84375 15.3125 9.5 14.5 9.5H10C10.4062 10.25 10.7188 11.0312 10.875 11.875L10.9688 12.2188C11.125 13.0312 10.5938 13.8125 9.78125 14ZM1 11C0.4375 11 0 10.5625 0 10V3C0 2.46875 0.4375 2 1 2H3C3.53125 2 4 2.46875 4 3V10C4 10.5625 3.53125 11 3 11H1Z",
    fill: "#FF2727"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbsDownFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbs-down-filled.2f3ce810.svg";
export { ForwardRef as ReactComponent };